import { ChevronDown } from 'lucide-react'

// Shared dropdown styling for the task property menus (status, priority, type,
// assignee, applicant, template picker).
export const TASK_MENU_CLASSNAMES = {
  dropdown: 'rounded shadow-sm p-1',
  item: 'text-doubleNickel-gray-700 text-xs p-2',
}

// Chevron shown on a task menu trigger to indicate it opens a dropdown.
export const MenuChevron = () => (
  <ChevronDown className="h-3 w-3 flex-shrink-0 text-doubleNickel-gray-400" />
)
